export const bundleAwareCartItems = (cartItems = []) => {
  const bundlesMap = new Map();
  const result = [];
  const resultImageId = localStorage.getItem("resultImageId");
  
  for (const item of cartItems) {
    const { bundleId, imageId } = item;
    if (bundleId) {
      const bundleKey = `${bundleId}-${imageId}`;
      if (!bundlesMap.has(bundleKey)) {
        bundlesMap.set(bundleKey, []);
      }
      bundlesMap.get(bundleKey).push(item);
    } else {
      result.push(item);
    }
  }
  
  for (const [bundleKey, items] of bundlesMap.entries()) {
    if (items.length > 1) {
      const bundleQuantity = Math.min(...items.map(item => item.quantity));
      result.push({
        type: "bundle",
        bundleId: items[0].bundleId,
        bundleCartId: items[0].bundleCartId,
        quantity: bundleQuantity,
        products: items,
        name: items[0].bundleName || "Bundle",
        cartId: `bundle-${items[0].bundleId}-${items[0].imageId}`,
        bundleRawTotal: items[0].bundleRawTotal,
        bundleTotal: items[0].bundleTotal,
        bundleDiscount: items[0].bundleDiscount,
      });
    } else {
      result.push(items[0]);
    }
  }
  
  return result;
};